// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCallFail24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.07762 3.21398C9.26003 3.20257 10.2678 4.06931 10.4342 5.24702C10.5097 5.81882 10.6366 6.38232 10.8131 6.9298L11.0124 7.51081C11.2488 8.32618 11.0281 9.21246 10.4217 9.8256L9.81693 10.43L9.94999 10.6384C10.8473 11.9949 12.009 13.1567 13.3656 14.054L13.5729 14.186L14.1813 13.5793C14.7917 12.9757 15.6778 12.7552 16.4918 12.991L16.665 13.0486C17.3404 13.3006 18.0422 13.4754 18.7636 13.5706C19.8942 13.7301 20.7394 14.6742 20.7883 15.7836L20.7898 18.3487C20.7925 19.012 20.5154 19.6458 20.0266 20.0942C19.5379 20.5426 18.8827 20.7642 18.2085 20.7031C15.6213 20.422 13.1361 19.5379 10.9584 18.1257C8.92561 16.834 7.20213 15.1105 5.91393 13.0832C4.493 10.8898 3.60872 8.39246 3.33159 5.78192C3.27208 5.12333 3.4921 4.47005 3.93792 3.98167C4.38371 3.49332 5.01421 3.2148 5.67628 3.21398H8.07762ZM8.09223 4.71398H5.67712C5.43682 4.71432 5.20772 4.81553 5.04576 4.99295C4.88381 5.17036 4.80388 5.40768 4.82435 5.63522C5.07545 7.99978 5.88001 10.2719 7.1764 12.2732C8.35004 14.1201 9.91595 15.686 11.7688 16.8634C13.7554 18.1518 16.0166 18.9561 18.3571 19.2106C18.597 19.2323 18.835 19.1518 19.0126 18.9889C19.1902 18.826 19.2908 18.5958 19.2898 18.3518L19.2901 15.9245C19.3008 15.4901 18.9844 15.1166 18.5608 15.0568C17.7339 14.9478 16.922 14.7455 16.1389 14.4533C15.8262 14.3357 15.4736 14.4109 15.239 14.6429L14.2194 15.6625C13.9806 15.9013 13.6118 15.9511 13.3183 15.7842C11.1909 14.5745 9.42945 12.8131 8.21978 10.6856C8.05289 10.3922 8.10268 10.0233 8.34142 9.7846L9.35812 8.76791C9.59303 8.53036 9.66822 8.17781 9.55003 7.86339C9.25844 7.08196 9.05619 6.27006 8.94807 5.45006C8.88795 5.02472 8.52182 4.70983 8.09223 4.71398ZM16.5303 3.46971C16.2374 3.17682 15.7625 3.17682 15.4696 3.46971L15.397 3.55383C15.1791 3.84744 15.2033 4.26411 15.4696 4.53037L17.414 6.47487L15.4696 8.41946C15.1767 8.71235 15.1767 9.18723 15.4696 9.48012C15.7625 9.77301 16.2374 9.77301 16.5303 9.48012L18.474 7.53487L20.4193 9.48012C20.7122 9.77301 21.1871 9.77301 21.48 9.48012L21.5526 9.396C21.7705 9.10239 21.7463 8.68573 21.48 8.41946L19.535 6.47387L21.48 4.53037C21.7729 4.23748 21.7729 3.76261 21.48 3.46971C21.1871 3.17682 20.7122 3.17682 20.4193 3.46971L18.474 5.41387L16.5303 3.46971Z"
				/>
			</Svg>
		);
	}
);
SvgCallFail24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCallFail24;
